import { tns } from 'tiny-slider/src/tiny-slider.module.js';

class ExhibitorCarousel {
	constructor(el) {
		this.carouselEl = el;

		if (this.carouselEl) {
			this.init();
		}
	}

	init() {
		this.carousel = tns({
			container: this.carouselEl,
			items: 4,
			slideBy: 1,
			autoplay: true,
			controls: true,
			autoplayButton: false,
			autoplayButtonOutput: false,
			autoplayHoverPause: true,
			nav: false,
			autoplayTimeout: 7000,
			// navContainer: document.querySelector('[data-ncomponent="hero-nav"]'),
			controlsContainer: this.carouselEl.parentNode.querySelector('[data-ncarouselnav="exhibitors"]'),
			touch: true,
			mouseDrag: false,
			responsive: {
				1080: {
					items: 4,
				},
				900: {
					items: 3,
				},
				560: {
					items: 2,
				},
				10: {
					items: 1,
				},
			},
		});
	}
}

class ExhibitorCarousels {
	constructor() {
		this.carouselEls = Array.from(
			document.querySelectorAll('[data-ncomponent="exhibitor-carousel"]')
		);

		this.carouselEls.forEach(el => new ExhibitorCarousel(el));
	}
}

export default new ExhibitorCarousels();
